// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   INTERVIEW PAGES - ACCELLOR BRANDING THEME
   Centralized design tokens following G42 brand guidelines
   ========================================== */

:root {
  /* Font Family - G42 Brand */
  --interview-font-primary: 'G42 Sans', 'Inter', sans-serif;

  /* Font Weights - G42 Standards */
  --interview-text-light: 300;
  --interview-text-regular: 400;
  --interview-text-medium: 500;
  --interview-text-semibold: 600;
  --interview-text-bold: 700;
  --interview-text-black: 900;

  /* Font Sizes - G42 Typography Scale */
  --interview-text-xs: 0.75rem;      /* 12px */
  --interview-text-sm: 0.8125rem;    /* 13px */
  --interview-text-base: 0.9375rem;  /* 15px */
  --interview-text-md: 1rem;         /* 16px */
  --interview-text-lg: 1.0625rem;    /* 17px */
  --interview-text-xl: 1.375rem;     /* 22px */
  --interview-text-2xl: 1.625rem;    /* 26px */
  --interview-text-3xl: 2.5rem;      /* 40px */

  /* Brand Colors - G42 Palette (from mockup) */
  --interview-brand-primary: #0F9D6B;
  --interview-brand-primary-hover: #0C895C;
  --interview-brand-primary-dark: #0A6E4A;

  /* Background Colors */
  --interview-bg-main: #EDF1EE;
  --interview-bg-white: #ffffff;
  --interview-bg-card: #ffffff;
  --interview-bg-input: #ffffff;
  --interview-bg-input-focus: #ffffff;

  /* Text Colors */
  --interview-text-primary: #13242C;
  --interview-text-secondary: #2B3A42;
  --interview-text-tertiary: #7A8B94;
  --interview-text-muted: #7A8B94;
  --interview-text-disabled: #9AA8B0;

  /* Status Colors - Aligned with G42 */
  --interview-success: #0F9D6B;
  --interview-success-light: #ECF8F1;
  --interview-success-lighter: #E3F5EC;
  --interview-success-dark: #0A6E4A;
  --interview-success-border: #C4E8D6;

  --interview-error: #ff4d4d;
  --interview-error-light: #fee2e2;
  --interview-error-dark: #991b1b;
  --interview-error-border: #fecaca;

  --interview-warning: #ffa500;
  --interview-warning-light: #fef3c7;
  --interview-warning-border: #fde68a;

  /* Border Colors */
  --interview-border-default: #D1DAE0;
  --interview-border-focus: var(--interview-brand-primary);
  --interview-border-light: #EAEEF1;

  /* Border Radius - G42 Standards */
  --interview-radius-sm: 6px;
  --interview-radius-md: 10px;
  --interview-radius-lg: 12px;
  --interview-radius-xl: 13px;
  --interview-radius-2xl: 14px;
  --interview-radius-3xl: 22px;
  --interview-radius-circle: 50%;

  /* Shadows - G42 Elevation */
  --interview-shadow-card: 0 20px 64px rgba(10, 36, 28, 0.12);
  --interview-shadow-button: 0 4px 12px rgba(15, 157, 107, 0.3);
  --interview-shadow-focus: 0 0 0 3px rgba(15, 157, 107, 0.1);

  /* Spacing Scale */
  --interview-space-xs: 4px;
  --interview-space-sm: 8px;
  --interview-space-md: 12px;
  --interview-space-lg: 16px;
  --interview-space-xl: 20px;
  --interview-space-2xl: 24px;
  --interview-space-3xl: 32px;
  --interview-space-4xl: 48px;

  /* Container Widths */
  --interview-container-sm: 400px;
  --interview-container-md: 490px;
  --interview-container-md-wide: 540px;
  --interview-container-lg: 600px;

  /* Transitions */
  --interview-transition-fast: 0.15s ease;
  --interview-transition-base: 0.2s ease;
  --interview-transition-slow: 0.3s ease;

  /* Z-Index Scale */
  --interview-z-dropdown: 1000;
  --interview-z-modal: 1050;
  --interview-z-tooltip: 1100;
}

/* Base styles for interview pages */
.interview-page-root {
  font-family: var(--interview-font-primary);
  font-size: 16px;
  line-height: 1.5;
  color: var(--interview-text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Responsive font size adjustments */
@media (max-width: 576px) {
  :root {
    --interview-text-2xl: 1.375rem;    /* 22px on mobile */
    --interview-text-xl: 1.25rem;      /* 20px on mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/interview-theme.css"],"names":[],"mappings":"AAAA;;;+CAG+C;;AAE/C;EACE,4BAA4B;EAC5B,yDAAyD;;EAEzD,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;;EAE3B,sCAAsC;EACtC,4BAA4B,OAAO,SAAS;EAC5C,8BAA8B,KAAK,SAAS;EAC5C,gCAAgC,GAAG,SAAS;EAC5C,yBAAyB,UAAU,SAAS;EAC5C,8BAA8B,KAAK,SAAS;EAC5C,6BAA6B,MAAM,SAAS;EAC5C,8BAA8B,KAAK,SAAS;EAC5C,4BAA4B,OAAO,SAAS;;EAE5C,6CAA6C;EAC7C,kCAAkC;EAClC,wCAAwC;EACxC,uCAAuC;;EAEvC,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;;EAEnC,gBAAgB;EAChB,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;;EAElC,qCAAqC;EACrC,4BAA4B;EAC5B,kCAAkC;EAClC,oCAAoC;EACpC,iCAAiC;EACjC,mCAAmC;;EAEnC,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;;EAEjC,4BAA4B;EAC5B,kCAAkC;EAClC,mCAAmC;;EAEnC,kBAAkB;EAClB,mCAAmC;EACnC,wDAAwD;EACxD,iCAAiC;;EAEjC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;;EAE9B,4BAA4B;EAC5B,2DAA2D;EAC3D,6DAA6D;EAC7D,2DAA2D;;EAE3D,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;;EAE/B,gBAAgB;EAChB,uCAAuC;EACvC,sCAAsC;EACtC,sCAAsC;;EAEtC,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE;IACE,8BAA8B,KAAK,mBAAmB;IACtD,4BAA4B,OAAO,mBAAmB;EACxD;AACF","sourcesContent":["/* ==========================================\n   INTERVIEW PAGES - ACCELLOR BRANDING THEME\n   Centralized design tokens following G42 brand guidelines\n   ========================================== */\n\n:root {\n  /* Font Family - G42 Brand */\n  --interview-font-primary: 'G42 Sans', 'Inter', sans-serif;\n\n  /* Font Weights - G42 Standards */\n  --interview-text-light: 300;\n  --interview-text-regular: 400;\n  --interview-text-medium: 500;\n  --interview-text-semibold: 600;\n  --interview-text-bold: 700;\n  --interview-text-black: 900;\n\n  /* Font Sizes - G42 Typography Scale */\n  --interview-text-xs: 0.75rem;      /* 12px */\n  --interview-text-sm: 0.8125rem;    /* 13px */\n  --interview-text-base: 0.9375rem;  /* 15px */\n  --interview-text-md: 1rem;         /* 16px */\n  --interview-text-lg: 1.0625rem;    /* 17px */\n  --interview-text-xl: 1.375rem;     /* 22px */\n  --interview-text-2xl: 1.625rem;    /* 26px */\n  --interview-text-3xl: 2.5rem;      /* 40px */\n\n  /* Brand Colors - G42 Palette (from mockup) */\n  --interview-brand-primary: #0F9D6B;\n  --interview-brand-primary-hover: #0C895C;\n  --interview-brand-primary-dark: #0A6E4A;\n\n  /* Background Colors */\n  --interview-bg-main: #EDF1EE;\n  --interview-bg-white: #ffffff;\n  --interview-bg-card: #ffffff;\n  --interview-bg-input: #ffffff;\n  --interview-bg-input-focus: #ffffff;\n\n  /* Text Colors */\n  --interview-text-primary: #13242C;\n  --interview-text-secondary: #2B3A42;\n  --interview-text-tertiary: #7A8B94;\n  --interview-text-muted: #7A8B94;\n  --interview-text-disabled: #9AA8B0;\n\n  /* Status Colors - Aligned with G42 */\n  --interview-success: #0F9D6B;\n  --interview-success-light: #ECF8F1;\n  --interview-success-lighter: #E3F5EC;\n  --interview-success-dark: #0A6E4A;\n  --interview-success-border: #C4E8D6;\n\n  --interview-error: #ff4d4d;\n  --interview-error-light: #fee2e2;\n  --interview-error-dark: #991b1b;\n  --interview-error-border: #fecaca;\n\n  --interview-warning: #ffa500;\n  --interview-warning-light: #fef3c7;\n  --interview-warning-border: #fde68a;\n\n  /* Border Colors */\n  --interview-border-default: #D1DAE0;\n  --interview-border-focus: var(--interview-brand-primary);\n  --interview-border-light: #EAEEF1;\n\n  /* Border Radius - G42 Standards */\n  --interview-radius-sm: 6px;\n  --interview-radius-md: 10px;\n  --interview-radius-lg: 12px;\n  --interview-radius-xl: 13px;\n  --interview-radius-2xl: 14px;\n  --interview-radius-3xl: 22px;\n  --interview-radius-circle: 50%;\n\n  /* Shadows - G42 Elevation */\n  --interview-shadow-card: 0 20px 64px rgba(10, 36, 28, 0.12);\n  --interview-shadow-button: 0 4px 12px rgba(15, 157, 107, 0.3);\n  --interview-shadow-focus: 0 0 0 3px rgba(15, 157, 107, 0.1);\n\n  /* Spacing Scale */\n  --interview-space-xs: 4px;\n  --interview-space-sm: 8px;\n  --interview-space-md: 12px;\n  --interview-space-lg: 16px;\n  --interview-space-xl: 20px;\n  --interview-space-2xl: 24px;\n  --interview-space-3xl: 32px;\n  --interview-space-4xl: 48px;\n\n  /* Container Widths */\n  --interview-container-sm: 400px;\n  --interview-container-md: 490px;\n  --interview-container-md-wide: 540px;\n  --interview-container-lg: 600px;\n\n  /* Transitions */\n  --interview-transition-fast: 0.15s ease;\n  --interview-transition-base: 0.2s ease;\n  --interview-transition-slow: 0.3s ease;\n\n  /* Z-Index Scale */\n  --interview-z-dropdown: 1000;\n  --interview-z-modal: 1050;\n  --interview-z-tooltip: 1100;\n}\n\n/* Base styles for interview pages */\n.interview-page-root {\n  font-family: var(--interview-font-primary);\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--interview-text-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Responsive font size adjustments */\n@media (max-width: 576px) {\n  :root {\n    --interview-text-2xl: 1.375rem;    /* 22px on mobile */\n    --interview-text-xl: 1.25rem;      /* 20px on mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
